import React from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage, Link } from "gatsby-plugin-intl";
import { Button, Header } from "semantic-ui-react";
import { Block } from "./StyledComponent";

export const BetaBannerHide = () => null;

export const BetaBanner = ({ intl }, { isMobile }) => {
  return (
    <Block textAlign="center" color="yellow" style={{ padding: "1em" }}>
      <Header
        as="h4"
        size="large"
        style={{ fontSize: "20px", fontWeight: "bold", margin: 0 }}
      >
        <FormattedMessage id="beta_banner" />
        <Button
          color="orange"
          size={isMobile ? "big" : "huge"}
          as={Link}
          name="beta"
          to="/beta"
          fluid={isMobile}
          style={{ marginLeft: 20 }}
          content={intl.formatMessage({ id: "beta_button" })}
        />
      </Header>
    </Block>
  );
};

BetaBanner.contextTypes = {
  isMobile: PropTypes.bool,
};

export default injectIntl(BetaBanner);
